export default __webpack_public_path__ + "static/media/en.84d4bb24.svg";